'use client';

import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import Link from 'next/link';
import styles from './Page404.module.scss';
import Text from '@/components/Text/Text';
import Button, { ButtonType } from '@/components/Button/Button';
import Img from '@/components/Img';

const Page404 = () => {
  const t = useTranslations('error');
  return (
    <div
      className={styles.notFound}
      style={{
        backgroundImage: `
          linear-gradient(0deg, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0.45) 100%),
          linear-gradient(0deg, rgba(250, 248, 245, 0.90) 0.2%, rgba(207, 177, 162, 0.00) 99.83%),
          url(/notFoundBg.png)
        `,
      }}
    >
      <Link
        href='/'
      >
        <Img
          local
          src='/logo.svg'
          alt='logo'
          width={370}
          height={40}
          className={styles.logo}
        />
      </Link>
      <div className={styles.text}>
        <Text
          tag='h1'
          className={clsx(styles.heading, 'font-kalnia')}
        >
          404
        </Text>
        <Text
          tag='h4'
          className={clsx(styles.heading, 'font-kalnia')}
        >
          {t('Page Not Found')}
        </Text>
      </div>
      <Button
        type={ButtonType.PRIMARY_LIGHT}
        fitContent
        href='/login'
      >
        {t('Back')}
      </Button>
    </div>
  );
};

export default Page404;
